export default __webpack_public_path__ + "static/media/CW.b77992e8.svg";